const BASE_URL = process.env.REACT_APP_BACKEND_CONNECTION || "";

function buildUrl(endpoint) {
  if (!endpoint) return BASE_URL;
  if (endpoint.startsWith("http")) return endpoint;
  return `${BASE_URL}${endpoint.startsWith("/") ? "" : "/"}${endpoint}`;
}

export async function apiFetch(endpoint, {
  method = "GET",
  token,
  body,
  headers = {},
  ...options
} = {}) {
  const finalHeaders = {
    ...headers,
  };

  if (token) {
    finalHeaders.Authorization = `Bearer ${token}`;
  }

  let payload = undefined;
  if (body !== undefined) {
    finalHeaders["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }

  const res = await fetch(buildUrl(endpoint), {
    method,
    headers: finalHeaders,
    body: payload,
    ...options,
  });

  if (!res.ok) {
    const text = await res.text();
    let parsed;
    try {
      parsed = JSON.parse(text);
    } catch {
      parsed = text;
    }

    const error = new Error(`Request failed ${res.status} ${res.statusText}`);
    error.status = res.status;
    error.body = parsed;
    throw error;
  }

  return res.json();
}
